<template>
  <div class="text-center">
    <div v-for="(row, index) in innerOptions" :key="index">
      <template v-for="(option, index) in row">
        <div v-if="option.value !== null" :key="index"
             :class="['d-inline-flex', 'space', 'square', 'my-1', ...option.class, innerSelected.includes(option.value) ? 'selected' : null]"
             :style="{width: ((17 * option.size) - 2) + 'vw'}"
             @click="select(option.value)" v-html="option.text">
        </div>
        <div v-else :key="index"
             :class="['d-inline-flex', 'space', 'my-1', ...option.class]"
             :style="{width: ((17 * option.size) - 2) + 'vw'}"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectWithButtons',
  props: {
    options: {required: true},
    rowSize: {default: Infinity},
    selected: {default: () => []}
  },
  computed: {
    innerSelected() {
      return Array.isArray(this.selected) ? this.selected : [this.selected];
    },
    innerOptions() {
      let tempOpts = this.options;
      if (!(tempOpts instanceof Array)) {
        tempOpts = Object.keys(tempOpts).map(key => {
          return {value: key, text: tempOpts[key]};
        });
      }

      tempOpts = tempOpts.map(value => {
        if (value === null) {
          value = {value: null};
        }
        return {
          value: value.value !== undefined ? value.value : value,
          text: value.text !== undefined ? value.text : value,
          size: value.size ?? 1,
          class: value.class ?? []
        };
      });

      const ret = [];
      let row = [];
      let cellCounter = 0;
      for (const opt of tempOpts) {
        if (cellCounter + opt.size > this.rowSize) {
          ret.push(row);
          row = [];
          cellCounter = 0;
        }
        cellCounter += opt.size;
        row.push(opt);
      }
      //Flush remaining incomplete row
      if (row.length > 0) {
        ret.push(row);
      }
      return ret;
    }
  },
  methods: {
    select(option) {
      this.$emit('click', option);
    }
  }
};
</script>

<style scoped>
.space {
  height: 15vw;
  margin-left: 1vw;
  margin-right: 1vw;
}

.square {
  color: black;
  font-size: 10vw;
  justify-content: center;
  background-color: transparent;
  border: 1px solid darkblue;
  border-radius: 0.5rem;
}

.selected {
  background-color: #ffdf7e;
}


</style>